export default {
    methods: {
        gotoBem (b, target = '_blank') {
            let router = this.$router || this.router
            let routeData = router.resolve({name: 'bens.show', params: {id: b.id}})
            window.open(routeData.href, '_blank')
        }
    }
}
